import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../webcommon/common/formcomponents/textinput/TextInput';
import SearchIcon from '../../../webcommon/common/Icons/Search.svg';
import ActionButton from '../../../webcommon/common/actionbutton/ActionButton';
import { noop } from 'lodash';
import defaultStyles from './RowSelector.module.scss';
import SelectRow from './SelectRow';
import DeleteRowModal from '../templates/deletetemplate/DeleteRowModal';

const RowSelector = (props) => {
    const [searchString, setSearchString] = useState('');
    const memoizedRows = useMemo(() => props.rows
        .filter(row => row.toLowerCase().includes(searchString.toLowerCase())),
    [props.rows, searchString]);

    return (
        <div className={ props.styles.rowSelectorWrapper }>
            <div className={ props.styles.rowSelectorHeader }>
                {props.title}
            </div>
            <div className={ props.styles.searchBox }>
                <TextInput
                    value={ searchString }
                    onChange={ e => setSearchString(e.target.value) }
                    placeholder={ `Search ${props.title}` }
                    icon={ SearchIcon }
                />
            </div>
            {memoizedRows.map(row => (
                <SelectRow
                    deleteRow={ props.openDeleteRow }
                    key={ row }
                    row={ row }
                    selectTemplate={ props.selectTemplate }
                    setSelected={ props.setSelected }
                />
            ))}
            <div className={ props.styles.closeButton }>
                <ActionButton
                    accent
                    onClick={ props.closeDropdown }
                >
                    Close
                </ActionButton>
            </div>
            {props.deletingRow ? (
                <DeleteRowModal
                    deleteRow={ props.deleteRow }
                    rowToDelete={ props.rowToDelete }
                    cancelDelete={ props.cancelDelete }
                />
            ) : null}
        </div>
    );
};

RowSelector.propTypes = {
    cancelDelete: PropTypes.func,
    closeDropdown: PropTypes.func,
    deleteRow: PropTypes.func,
    deletingRow: PropTypes.bool,
    openDeleteRow: PropTypes.func,
    rows: PropTypes.arrayOf(PropTypes.string),
    rowToDelete: PropTypes.string,
    selectTemplate: PropTypes.func,
    setSelected: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string
};

RowSelector.defaultProps = {
    cancelDelete: noop,
    closeDropdown: noop,
    deleteRow: noop,
    openDeleteRow: noop,
    deletingRow: false,
    rows: [],
    rowToDelete: '',
    selectTemplate: noop,
    setSelected: noop,
    styles: defaultStyles,
    title: ''
};

export default RowSelector;
